import { stats } from '@/mocks/homeContent';

export default function AboutSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-900 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.08) 0%, transparent 50%)'
        }}></div>
      </div>

      <div className="relative w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 md:gap-16">
          <div className="lg:w-1/2">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-background-800 rounded-full mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
              <span className="text-xs text-background-200 font-medium whitespace-nowrap">// About</span>
            </div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-white leading-tight mb-6">
              The Ultimate Spreadsheet Resource for Smart Shoppers
            </h2>
            <p className="text-sm md:text-base text-background-300 leading-relaxed mb-8">
              We built the most comprehensive superbuy spreadsheet to help international buyers navigate the world of agent shopping. Our curated collection saves you time, eliminates guesswork, and connects you directly with trusted sellers across every product category. Whether you are looking for the latest streetwear, affordable sneakers, or unique accessories, our spreadsheet puts everything at your fingertips.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3 bg-background-50 text-foreground-900 text-sm font-semibold rounded-full hover:bg-white transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore Kaspreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:w-1/2">
            <div className="relative">
              <div className="aspect-square rounded-2xl overflow-hidden bg-background-800">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20desk%20with%20large%20monitor%20displaying%20colorful%20spreadsheet%20data%20surrounded%20by%20neatly%20arranged%20product%20samples%20fabric%20swatches%20and%20fashion%20lookbook%20magazines%20on%20a%20warm%20oak%20surface%20soft%20natural%20daylight%20from%20large%20window%20creating%20bright%20airy%20atmosphere%20editorial%20interior%20lifestyle%20photography&width=800&height=800&seq=about-workspace-fresh-v2&orientation=squarish"
                  alt="Superbuy Spreadsheet Workspace"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-accent-500 text-white px-8 py-6 rounded-2xl">
                <p className="text-4xl md:text-5xl font-heading font-bold">{stats.value}</p>
                <p className="mt-1 text-sm text-white/80 font-medium">{stats.label}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}